import React from 'react';
import styles from './css/BreadCrumbs.styl';

const BreadCrumbs = props => {
  const {byPageUrl, name, pageTypeClass} = props;

  return (
    <div className={styles[pageTypeClass] || styles.BreadCrumbs}>
      <a href="/" target="_self">
        Home
      </a>
      <a href={byPageUrl} target="_self">
        Obituaries
      </a>
      {name && name.short ? (
        <a className={styles.active} href="#">
          {name.short} Obituary
        </a>
      ) : null}
    </div>
  );
};

BreadCrumbs.propTypes = {
  byPageUrl: React.PropTypes.string,
  name: React.PropTypes.object,
  pageTypeClass: React.PropTypes.string,
};

export default BreadCrumbs;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/PersonHero/BreadCrumbs.js